import React, { useContext, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import FeatureBox from "../../components/FeatureBox";
import TopBanner from "../../components/TopBanner";
import { useHistory, useParams } from "react-router-dom";
import Header from "./../../components/header";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import {
  fullName,
  getErrorString,
  getUserDetail,
  isEmpty,
  isOwner,
  isOwnerId,
} from "./../../constants/function";
import Player from "./../../components/Player";
import { useSelector, useDispatch } from "react-redux";
import { Avatar, Chip, Stack, Typography } from "@mui/material";
import Chips from "./../../components/Chips";
import { addSongAction, addSongsAction } from "./../../action/songs";
import OutsideClickHandler from "react-outside-click-handler";
import DropMenu from "../../components/DropMenu";
import DoneIcon from "@mui/icons-material/Done";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Images } from "../../assets/common";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import { useTranslation } from "react-i18next";

import { UserContext } from "../../context/userContext";
import DobPopup from "../../components/DobPopup";
import { startStream } from "../../action/stream";
import { SocketContext } from "../../context/socket";
export default function Home() {
  const socket = useContext(SocketContext).Socket;
  const { isStream } = useSelector((state) => state.stream);
  const [message, setMessage] = React.useState(null);
  const { t, i18n } = useTranslation("common");
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const songs = useSelector((state) => state.songs);
  const previousSong = React.useRef(songs);
  const [open, setOpen] = useState(false);
  const [featureMusic, setFeaturemusic] = useState([]);
  const [featureArtist, setFeatureArtist] = useState([]);
  const [featureUser, setFeatureUser] = useState([]);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [isAlbum, setIsAlbum] = React.useState(false);

  const [birthYear, setBirthYear] = React.useState(false);
  // const { userData } = useContext(UserContext);
  const userData = getUserDetail();
  const [featurePlaylist, setFeaturePlaylist] = useState([]);
  const [music, setMusic] = useState({});
  const [nft, setNft] = useState({});
  const [loading, setLoading] = useState(false);
  const [liveStream, setLiveStream] = useState([]);
  const streamRef = React.useRef([]);
  const [selectedSong, setSelectedSong] = useState();
  const { tab } = useParams();
  const getFeatureMusic = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_MUSIC("");
      setFeaturemusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getFeatureUser = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_USER("");
      setFeatureUser([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getFeatureArtist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_ARTIST("");
      setFeatureArtist([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getFeaturePlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_PLAYLIST("");
      setFeaturePlaylist([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getLiveStreams = async () => {
    try {
      // setLoading(true);
      const response = await ApiService.LIVESTREAM();
      setLiveStream([...response["result"]]);
      streamRef.current = response["result"];
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  React.useEffect(() => {
    // getFeatureMusic();
    // getFeatureUser();
    // getFeaturePlaylist();
    // getFeatureArtist();
    // getLiveStreams();
    const activetab = tab === "featured" || !tab ? 0 : tab === "music" ? 1 : 2;
    setActiveTab(activetab);
    switch (activetab) {
      case 0:
        getFeatureMusic();
        getFeatureUser();
        getFeaturePlaylist();
        getFeatureArtist();
        getLiveStreams();
        break;
      case 1:
        getAllMusics();
        break;
      case 3:
        getAllNfts();
        break;
      case 2:
        getAllPlaylists();
        break;
      default:
        break;
    }
  }, [tab]);
  useEffect(() => {
    if (socket) {
      socket.on("stream-joined", streamJoined);
      socket.on("stream-ended", streamEnd);
      // socket.on("audience-in-stream", audience);
    }
  }, [socket]);

  const streamJoined = (streamData) => {
    // const index = findStream(streamData.channelName);
    // if (index < 0) getLiveStreams();
    if (streamData.livestreamData) {
      const stream = streamRef.current;

      let show = false;
      stream.forEach((e) => {
        if (e.channelName === streamData?.livestreamData?.channelName) {
          // console.log("e-channelName:::>>>", e.channelName);
          show = true;
        }
      });

      if (!show) {
        stream.unshift(streamData.livestreamData);
      }
      setLiveStream([...stream]);
      streamRef.current = stream;
    }
  };
  const streamEnd = (data) => {
    const index = findStream(data.channelName);
    if (index >= 0) {
      const stream = streamRef.current;
      stream.splice(index, 1);
      setLiveStream([...stream]);
      streamRef.current = stream;
    }
  };
  const audience = (audienceData) => {
    const index = findStream(audienceData.channelName);
    if (index >= 0) {
      const stream = streamRef.current;
      stream[index].audienceCount = audienceData.liveUsers.length;
      setLiveStream([...stream]);
      streamRef.current = stream;
    }
  };
  React.useEffect(() => {}, [songs]);

  const toggleMenu = (value, id, index, tab, music, isPlaylistNft) => {
    setSelectedAlbum(id);
    if (value && id) makeAction(value, id, index, tab, music, isPlaylistNft);
  };
  const makeAction = async (key, id, index, tab, music, isPlaylistNft) => {
    switch (key) {
      case "View Song Information":
        history.push(`/app/SongDetails/${id}`);
        break;
      case "View Artist":
        history.push(`/app/ArtistProfile/${id}`);
        break;
      case "Mark this Asset Private":
        markPrivate(id, index);
        break;
      case "Mark this Asset Public":
        markPrivate(id, index);
        break;
      case "Add to Studio":
        if (
          tab &&
          tab === 1 &&
          typeof music[index]["uploader"] === "object" &&
          !isOwnerId(
            music[index]["uploader"] ? music[index]["uploader"]["_id"] : ""
          ) &&
          !music[index]["uploader"]["isSubscribed"] &&
          music[index]["private"]
        )
          notifier.error(t("notifier.error.toast5"));
        else if (
          tab &&
          tab === 1 &&
          !isOwnerId(
            music[index]["uploader"] ? music[index]["uploader"] : ""
          ) &&
          !music[index]["isSubscribed"] &&
          music[index]["private"]
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          setIsAlbum(false);
          setShowPlaylist(true);
        }

        break;
      case "View Statistics":
        history.push(
          `/app/PlaylistStatics/${music[index]["_id"]}/${
            music[index]["creatorId"]
              ? music[index]["creatorId"]
              : music[index]["createdBy"]
          }`
        );
        break;

      case "Add song to Queue":
        if (tab === 2 && !isPlaylistNft) {
          const nftMusic = await getNftMusic(music[index]["nftId"]);
          if (!isEmpty(nftMusic)) dispatch(addSongAction(nftMusic, null, true));
        } else if (tab === 2 && isPlaylistNft) {
          const nftMusic = await getPlayListMusic(music[index]["_id"]);
          if (nftMusic && nftMusic.length > 0)
            dispatch(addSongsAction(nftMusic, false, music[index]["_id"]));
        } else if (tab === 0) {
          if (
            !isOwner(
              featureMusic[index]["uploader"]
                ? featureMusic[index]["uploader"]["email"]
                : ""
            ) &&
            featureMusic[index]["uploader"] &&
            !featureMusic[index]["uploader"]["isSubscribed"] &&
            featureMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast5"));
          else dispatch(addSongAction(featureMusic[index], null, true));
        } else if (tab === 1) {
          if (
            !isOwnerId(
              music[index]["uploader"] ? music[index]["uploader"] : ""
            ) &&
            !music[index]["isSubscribed"] &&
            music[index]["private"]
          )
            notifier.error(t("notifier.error.toast5"));
          else dispatch(addSongAction(music[index], null, true));
        }

        break;
      case "Add all songs to Queue":
        if (
          tab &&
          tab === 3 &&
          !isOwnerId(
            music[index]["createdBy"] ? music[index]["createdBy"] : ""
          ) &&
          !music[index]["isSubscribed"] &&
          music[index]["private"]
        )
          notifier.error(t("notifier.error.toast5"));
        else if (tab && tab === 3) {
          const tempMusic = await getPlayListMusic(id);
          if (tempMusic && tempMusic.length > 0)
            dispatch(addSongsAction(tempMusic, false, id, 0));
        } else {
          if (
            !isOwner(
              featurePlaylist[index]["createdByDetails"]
                ? featurePlaylist[index]["createdByDetails"]["email"]
                : ""
            ) &&
            featurePlaylist[index]["createdByDetails"] &&
            !featurePlaylist[index]["createdByDetails"]["isSubscribed"] &&
            featurePlaylist[index]["private"]
          )
            notifier.error(t("notifier.error.toast5"));
          else
            dispatch(
              addSongsAction(
                featurePlaylist[index]["music"],
                false,
                featurePlaylist[index]["_id"]
              )
            );
        }
        break;
      default:
        break;
    }
  };
  const playSongs = (songs, index) => {
    if (songs.length > 0) dispatch(addSongsAction(songs, false, null, index));
  };

  const getNftMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_BY_ID(_id);
      const detail = response["result"];

      setLoading(false);
      return response["result"]["musicDetails"] || {};
    } catch (error) {
      setLoading(false);
      return {};
    }
  };
  const getPlaylistNftMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_NFT_BY_ID(_id);

      setLoading(false);
      return response["result"]["playlistDetails"] || {};
    } catch (error) {
      setLoading(false);
      return {};
    }
  };

  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });

      setLoading(false);

      return response["result"]["music"] || [];
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
      return [];
    }
  };
  const markPrivate = async (id, index) => {
    try {
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: id,
        type: "playlist",
        private: !featurePlaylist[index].private,
      });

      const temp = featurePlaylist;
      temp[index].private = !temp[index].private;
      setFeaturePlaylist([...temp]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleTabs = (e) => {
    history.push(
      `/app/Home/${e === 0 ? "featured" : e === 1 ? "music" : "studio"}`
    );
    // setActiveTab(e);
    // switch (e) {
    //   case 0:
    //     getFeatureMusic();
    //     getFeatureUser();
    //     getFeaturePlaylist();
    //     getFeatureArtist();
    //     getLiveStreams();
    //     break;
    //   case 1:
    //     getAllMusics();
    //     break;
    //   case 3:
    //     getAllNfts();
    //     break;
    //   case 2:
    //     getAllPlaylists();
    //     break;
    //   default:
    //     break;
    // }
  };

  const getAllMusics = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_ALL();
      const m = music;
      setMusic({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getAllNfts = async () => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_ALL();
      const m = music;
      setNft({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getAllPlaylists = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_ALL();
      const m = music;
      setNft({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    //console.log(music);
  }, [music]);

  const isSticky = (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;
    // if (a >= 250) {
    //   const header = document.querySelector("._tab_selection");
    //   header.classList.add("is-sticky");
    // } else {
    //   const header = document.querySelector("._tab_selection");
    //   header.classList.remove("is-sticky");
    // }
  };
  let year = new Date().getFullYear() - userData["birthYear"];
  // const popup = async () => {
  //   // console.log(userData["birthYear"]);
  //   // console.log(music["isExplicit"], !userData["dob"]);
  //   if ((music["isExplicit"] && !userData["birthYear"]) || year < 18) {
  //     return setBirthYear(true);
  //   }
  // };

  const handleTip = async () => {
    setBirthYear(false);
    // console.log(birthYear);
  };
  const handleClick = (channelName) => {
    getPlaylistDetail(channelName);
  };
  const getPlaylistDetail = async (channelName) => {
    if (!isStream) {
      try {
        setLoading(true);
        setMessage(t("loader.message14"));
        const response = await ApiService.PLAYLIST_DETAIL({
          _id: channelName,
          pageNo: 1,
          pageSize: 1,
        });
        if (!response?.result?.live) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast3"));

          return;
        }
        if (
          response?.result?.live &&
          !response?.result?.isSubscribed &&
          response?.result?.private
        ) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast4"));

          return;
        }
        const status = await getBlockedUserOfPlaylist(channelName);
        if (typeof status === "boolean" && status) {
          notifier.error(t("notifier.error.toast2"));
          setLoading(false);
          return;
        }
        dispatch(
          startStream({
            streamData: response?.result,
            title: null,
            goal: null,
            goalDescription: null,
          })
        );
        setLoading(false);
        setMessage(null);
      } catch (error) {
        if (
          getErrorString(error) ===
          "This is an explicit content you need to be above 18 to view it"
        ) {
          notifier.error(getErrorString(error));
        }
        setLoading(false);
        setMessage(null);
      }
    } else notifier.warning("You have already joined a live stream");
  };
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };

  const findStream = (channelName) => {
    const index = streamRef.current.findIndex(
      (s) => s.channelName === channelName
    );
    return index;
  };
  return (
    <Box sx={{ position: "relative" }}>
      {/* <Header toggleDrawer={() => setOpen(!open)} /> */}
      <Box
        onScroll={(e) => isSticky(e.target)}
        className={"__main_pading __home_no_player"}
        style={{ position: "relative" }}
      >
        <TopBanner />
        <Stack
          className="_tab_selection is-sticky"
          direction="row"
          overflow="scroll"
          justifyContent={"center"}
        >
          {[
            t("home.tabs.featured.tab"),
            t("home.tabs.music.tab"),
            //  "NFT",
            t("home.tabs.studio.tab"),
          ].map((m, index) => (
            <Stack
              key={index}
              direction="column"
              style={{ width: "80px", cursor: "pointer" }}
              alignItems={"center"}
              onClick={() => handleTabs(index)}
              gap={"10px"}
            >
              {" "}
              {activeTab === index ? (
                <Box
                  style={{
                    height: "4px",
                    width: "80px",
                    backgroundColor: "#FFEE20",
                    transition: "background-color 0.3s ease",

                    borderRadius:
                      index == 0
                        ? "8px 0 0 8px"
                        : index == 2
                        ? "0 8px 8px 0"
                        : "0px",
                  }}
                />
              ) : (
                <Box
                  style={{
                    height: "4px",
                    width: "80px",
                    backgroundColor: "grey",
                    transition: "background-color 0.3s linear",
                    borderRadius:
                      index == 0
                        ? "8px 0 0 8px"
                        : index == 2
                        ? "0 8px 8px 0"
                        : "0px",
                  }}
                />
              )}
              <Typography
                style={{ color: activeTab === index ? "#FFEE20" : "" }}
                className={"_cp fs-14"}
              >
                {m}
              </Typography>
            </Stack>
          ))}
        </Stack>

        {activeTab === 0 ? (
          <Box>
            {liveStream.length > 0 ? (
              <FeatureBox
                isStreaming={true}
                title={t("home.tabs.featured.header5")}
                route={"/app/feature/NowLive"}
                music={liveStream}
                hideIcons={true}
                isPlaylistNft={true}
                onStream={(channelName) => handleClick(channelName)}
              />
            ) : null}

            <FeatureBox
              isMusic={true}
              music={featureMusic}
              title={t("home.tabs.featured.header1")}
              route={"/app/feature/music"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 0)
              }
              isHome={true}
              playSongs={(index) => {
                if (!userData["birthYear"]) {
                  setBirthYear(true);
                  setSelectedSong({ featureMusic: featureMusic, index: index });
                } else {
                  playSongs(featureMusic, index);
                }
              }}
              hideIcons={true}
            />

            <FeatureBox
              isArtist={true}
              music={featureArtist}
              title={t("home.tabs.featured.header2")}
              route={"/app/feature/artists"}
              actions={["View Artist"]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 0)
              }
              hideIcons={true}
            />

            <FeatureBox
              isPlaylist={true}
              music={featurePlaylist}
              isFeature={true}
              title={t("home.tabs.featured.header3")}
              route={"/app/feature/studios"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 0, featurePlaylist)
              }
              hideIcons={true}
            />
            <FeatureBox
              isArtist={true}
              music={featureUser}
              title={t("home.tabs.featured.header4")}
              route={"/app/feature/users"}
              actions={["View Artist"]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 0, featureUser)
              }
              hideIcons={true}
            />
          </Box>
        ) : activeTab === 1 ? (
          <Box>
            <FeatureBox
              isMusic={true}
              music={music["newrelease"]}
              title={t("home.tabs.music.header1")}
              route={"/app/feature/NewRelease"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 1, music["newrelease"])
              }
              isHome={true}
              playSongs={(index) => {
                if (!userData["birthYear"]) {
                  setBirthYear(true);
                  setSelectedSong({
                    featureMusic: music["newrelease"],
                    index: index,
                  });
                } else {
                  playSongs(music["newrelease"], index);
                }
              }}
              hideIcons={true}
            />
            <FeatureBox
              isMusic={true}
              music={music["moststreamtoday"]}
              title={t("home.tabs.music.header2")}
              route={"/app/feature/MostStreamToday"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 1, music["moststreamtoday"])
              }
              isHome={true}
              playSongs={(index) => {
                if (!userData["birthYear"]) {
                  setBirthYear(true);
                  setSelectedSong({
                    featureMusic: music["moststreamtoday"],
                    index: index,
                  });
                } else {
                  playSongs(music["moststreamtoday"], index);
                }
              }}
              hideIcons={true}
            />

            <FeatureBox
              isMusic={true}
              music={music["moststreamthisweek"]}
              title={t("home.tabs.music.header3")}
              route={"/app/feature/MostStreamThisWeek"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 1, music["moststreamthisweek"])
              }
              isHome={true}
              playSongs={(index) => {
                if (!userData["birthYear"]) {
                  setBirthYear(true);
                  setSelectedSong({
                    featureMusic: music["moststreamthisweek"],
                    index: index,
                  });
                } else {
                  playSongs(music["moststreamthisweek"], index);
                }
              }}
              hideIcons={true}
            />
            <FeatureBox
              isMusic={true}
              music={music["mosttipped"]}
              title={t("home.tabs.music.header4")}
              route={"/app/feature/MostTipped"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 1, music["mosttipped"])
              }
              isHome={true}
              playSongs={(index) => {
                if (!userData["birthYear"]) {
                  setBirthYear(true);
                  setSelectedSong({
                    featureMusic: music["mosttipped"],
                    index: index,
                  });
                } else {
                  playSongs(music["mosttipped"], index);
                }
              }}
              hideIcons={true}
            />
          </Box>
        ) : activeTab === 2 ? (
          <Box>
            <FeatureBox
              isPlaylist={true}
              isPlaylistNft={true}
              music={nft["newRelease"]}
              title={t("home.tabs.studio.header1")}
              route={"/app/feature/NewReleaseStudio"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 3, nft["newRelease"])
              }
              hideIcons={true}
            />
            <FeatureBox
              isPlaylist={true}
              isPlaylistNft={true}
              music={nft["mostStreamedToday"]}
              title={t("home.tabs.studio.header2")}
              route={"/app/feature/MostStreamedTodayStudio"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 3, nft["mostStreamedToday"])
              }
              hideIcons={true}
            />

            <FeatureBox
              isPlaylist={true}
              isPlaylistNft={true}
              music={nft["mostStreamedThisWeek"]}
              title={t("home.tabs.studio.header3")}
              route={"/app/feature/MostStreamedThisWeekStudio"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 3, nft["mostStreamedThisWeek"])
              }
              hideIcons={true}
            />
            <FeatureBox
              isPlaylist={true}
              isPlaylistNft={true}
              music={nft["moststreamed"]}
              title={t("home.tabs.studio.header4")}
              route={"/app/feature/MostStreamed"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 3, nft["moststreamed"])
              }
              hideIcons={true}
            />

            <FeatureBox
              isPlaylist={true}
              isPlaylistNft={true}
              music={nft["mosttipped"]}
              title={t("home.tabs.studio.header5")}
              route={"/app/feature/MostTippedStudio"}
              actions={[
                "Add all songs to Queue",
                "Mark this Asset Private",
                "View Statistics",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 3, nft["mosttipped"])
              }
              hideIcons={true}
            />
          </Box>
        ) : activeTab === 3 ? (
          <Box>
            <FeatureBox
              isNft={true}
              music={nft["mostexpensive"]}
              title="Most Expensive NFTs"
              route={"/app/feature/mostexpensivenft"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 2, nft["mostexpensive"])
              }
              hideIcons={true}
            />
            <FeatureBox
              isNft={true}
              isPlaylistNft={true}
              music={nft["playlistmostexpensive"]}
              title="Most Expensive Playlist NFTs"
              route={"/app/feature/playlistmostexpensive"}
              actions={["Add song to Queue", "Add to Studio"]}
              toggleMenu={(action, id, index) =>
                toggleMenu(
                  action,
                  id,
                  index,
                  2,
                  nft["playlistmostexpensive"],
                  true
                )
              }
              hideIcons={true}
            />
            <FeatureBox
              isNft={true}
              music={nft["leastexpensive"]}
              title="Most Least Music NFTs"
              route={"/app/feature/leastexpensive"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 2, nft["leastexpensive"])
              }
              hideIcons={true}
            />
            <FeatureBox
              isNft={true}
              isPlaylistNft={true}
              music={
                nft["playlistleastexpensive"]
                  ? nft["playlistleastexpensive"]
                  : []
              }
              title="Most Least Playlist NFTs"
              route={"/app/feature/playlistleastexpensive"}
              actions={["Add song to Queue", "Add to Studio"]}
              toggleMenu={(action, id, index) =>
                toggleMenu(
                  action,
                  id,
                  index,
                  2,
                  nft["playlistleastexpensive"],
                  true
                )
              }
              hideIcons={true}
            />
            <FeatureBox
              isNft={true}
              ownerRoyalty={true}
              music={nft["ownerpercentage"] ? nft["ownerpercentage"] : []}
              title="NFT Based on Owner %"
              route={"/app/feature/ownerpercentage"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 2, nft["ownerpercentage"])
              }
              hideIcons={true}
            />
            <FeatureBox
              isNft={true}
              music={nft["endingsoonauction"] ? nft["endingsoonauction"] : []}
              title="Ending Soon"
              route={"/app/feature/endingsoonauction"}
              actions={[
                "Add song to Queue",
                "Add to Studio",
                "View Song Information",
              ]}
              toggleMenu={(action, id, index) =>
                toggleMenu(action, id, index, 2, nft["endingsoonauction"])
              }
              hideIcons={true}
            />
          </Box>
        ) : null}
        {birthYear ? (
          <DobPopup
            open={birthYear}
            handleClose={() => handleTip()}
            playAfterSubmit={() =>
              playSongs(selectedSong.featureMusic, selectedSong.index)
            }
          />
        ) : null}
      </Box>
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          isAlbum={isAlbum}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {loading ? <Loader message={message} /> : null}
    </Box>
  );
}
